import { useContext, useEffect, useState } from 'react';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import { Context } from '../../../AuthContext';

// Per-vertical email notification preferences. Both default to ON.
const SETTINGS = [
  { key: 'new_announcement', label: 'New Announcement Notifications' },
  { key: 'new_task_assigned', label: 'New Task Assigned Notifications' },
];

const NotificationSettings = ({ verticalId }) => {
  const { user } = useContext(Context);
  const [settings, setSettings] = useState({
    new_announcement: true,
    new_task_assigned: true,
  });

  useEffect(() => {
    const fetchSettings = async () => {
      if (!user || !verticalId) return;
      try {
        const token = await user.getIdToken();
        const res = await fetch(
          `${
            process.env.REACT_APP_FLASK_WEBSERVER
          }get_notification_settings?vertical_id=${encodeURIComponent(verticalId)}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (res.ok) setSettings(await res.json());
      } catch (err) {
        console.error('Failed to fetch notification settings:', err);
      }
    };
    fetchSettings();
  }, [user, verticalId]);

  const handleToggle = async (key) => {
    const previous = settings;
    const value = !settings[key];
    setSettings((prev) => ({ ...prev, [key]: value }));
    try {
      const token = await user.getIdToken();
      const res = await fetch(
        `${process.env.REACT_APP_FLASK_WEBSERVER}update_notification_settings`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ vertical_id: verticalId, [key]: value }),
        }
      );
      if (!res.ok) throw new Error(`Status ${res.status}`);
    } catch (err) {
      console.error('Failed to update notification settings:', err);
      setSettings(previous);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <Typography sx={{ fontSize: '20px', fontWeight: 700, mb: 1 }}>
        Notification Settings
      </Typography>
      {SETTINGS.map(({ key, label }) => (
        <FormControlLabel
          key={key}
          control={
            <Switch
              size="small"
              checked={settings[key]}
              onChange={() => handleToggle(key)}
              inputProps={{ 'aria-label': label }}
            />
          }
          label={label}
          sx={{ ml: 0, gap: 1 }}
        />
      ))}
    </Box>
  );
};

export default NotificationSettings;
